import { jsx } from '@emotion/react';
import { daysFromNow, parseDateTime } from '@zapier/date';
import { Alert, Link } from '@zapier/design-system';
import { UserInteractionEvent } from '../../../../universal-nav/utils/avroEvents';
import { buildUpgradeUrl } from './utils';
import { useUniversalNavContext } from '../../../../universal-nav/hooks';
export const shouldRender = (data) => {
    const { isCompanyAccount, companiesTrialEndDate } = data.currentAccount;
    if (!companiesTrialEndDate || isCompanyAccount)
        return false;
    const companiesTrialHasEnded = parseDateTime(companiesTrialEndDate) < new Date();
    return companiesTrialHasEnded && daysFromNow(companiesTrialEndDate) <= 7;
};
export const Component = function CompaniesTrialEnded(props) {
    var _a;
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const { data } = props;
    const upgradeUrl = buildUpgradeUrl({
        upgradePlanId: (_a = data.nextCompanyPlan) === null || _a === void 0 ? void 0 : _a.id,
    });
    const onUpgrade = () => {
        props.trackEvent(UserInteractionEvent, {
            interaction_name: 'company_trial_ended_banner_cta_clicked',
            interaction_goal: 'upgrade_plan',
            event_action: 'click',
            option_selected: 'not_applicable',
        });
    };
    const onContactSupport = () => {
        props.trackEvent(UserInteractionEvent, {
            interaction_name: 'company_trial_ended_banner_cta_clicked',
            interaction_goal: 'contact_support',
            event_action: 'click',
            option_selected: 'not_applicable',
        });
    };
    return (jsx(Alert, { variant: props.variant, title: "Your Company trial has ended", status: "info" },
        jsx(Link, { href: getFullyQualifiedURL(upgradeUrl), onClick: onUpgrade }, "Upgrade"),
        ' ',
        "to keep using our advanced administrative and security controls. Still have questions?",
        ' ',
        jsx(Link, { href: getFullyQualifiedURL('/app/get-help'), onClick: onContactSupport }, "Contact us"),
        ' '));
};
//# sourceMappingURL=CompaniesTrialEnded.js.map
// @zapier/universal-layout@11.2.3 (b1a6e8603)
